import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`It is not currently possible to change your npm username.  You'll need to
create a new account and migrate the data to the new account manually.`}</p>
    <ol>
      <li parentName="ol">{`Create a `}<a parentName="li" {...{
          "href": "/creating-a-new-npm-user-account"
        }}>{`new user account`}</a>{` with your desired username`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "/transferring-a-package-from-a-user-account-to-another-user-account"
        }}>{`Transfer your packages`}</a>{` to your new account.`}</li>
      <li parentName="ol">{`If you are a member of any `}<a parentName="li" {...{
          "href": "/organizations"
        }}>{`organizations`}</a>{`, ask the organization administrator to `}<a parentName="li" {...{
          "href": "/adding-members-to-your-organization"
        }}>{`invite your new account to the organization`}</a>{`.`}</li>
      <li parentName="ol">{`Delete your `}<a parentName="li" {...{
          "href": "/deleting-your-npm-user-account"
        }}>{`original account`}</a>{`.  Note that this is permanent, and after 30 days, this account name is available for other people to claim.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      